import React from "react";
import { formatNumber } from "../../../../../Utils/utils";

interface SecondCardRecalculateModalityProps {
  data: any;
  modalityData: any;
  selectedModality: any;
  hasModalityData: any;
}

const SecondCardRecalculateModality = ({
  data,
  modalityData,
  selectedModality,
  hasModalityData,
}: SecondCardRecalculateModalityProps) => {
  return (
    <div className="card-verify ">
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">
            Total capital pensión original
          </div>
          <div className="card-verify__data">
            {formatNumber.new(parseFloat(data.fondo.capitalPension).toFixed(2))}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Renta vitalicia original</div>
          <div className="card-verify__data">
            {hasModalityData && (modalityData.primaPensionRv || modalityData.primeraPensionRVD)
              ? formatNumber.new(modalityData.primaPensionRv || modalityData.primeraPensionRVD)
              : "--"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Renta temporal original</div>
          <div className="card-verify__data">
            {hasModalityData && (modalityData.primaPensionRt || modalityData.primeraPensionRT)
              ? formatNumber.new(modalityData.primaPensionRt || modalityData.primeraPensionRT)
              : "--"}
          </div>
        </div>
      </div>
      <div className="card-verify__rows-line"></div>
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">Gasto de sepelio</div>
          <div className="card-verify__data">
            {hasModalityData && modalityData.gastoSepelio
              ? formatNumber.new(modalityData.gastoSepelio)
              : "--"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Tipo de cambio</div>
          <div className="card-verify__data">
            {(selectedModality && selectedModality.tipoCambio) || (data && data.tipoCambio) || "--"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Ajuste IPC</div>
          <div className="card-verify__data">{(selectedModality && selectedModality.ajusteIPC) || (data && data.modalidadGanada && data.modalidadGanada.ajusteIPC) || "--"}</div>
        </div>
      </div>
    </div>
  );
};

export default SecondCardRecalculateModality;
